import BaseService from './baseService';

class Pesanan extends BaseService {
	async getPesanan(opts = {}) {
    // if(window.localStorage.getItem('user_role') == 'stockiest'){
    //   this.endPoint = '/get-submission-category-company/'+JSON.parse(window.localStorage.getItem('category')).id;
    // }else{
      this.endPoint = '/get-submission-category?category_id='+JSON.parse(window.localStorage.getItem('category')).id;
    // }
		return this.get(opts);
  }
  async getPesananById(id,opts = {}) {
		this.endPoint = '/submission-pos/' + id;
		return this.get(opts);
  }
  async getPesananByCompany(opts = {}) {
		this.endPoint = '/get-all-submission';
		return this.get(opts);
  }
  async createPesanan(payload){
    this.endPoint = '/submission';
    return await this.post(payload); 
  }
  async updatePesanan(id,payload,opts={}){
    this.endPoint = '/submission';
    return await this.putOne(id,payload,opts);
  }
  async updateStatusPesanan(id,payload,opts={}){
    this.endPoint = '/update-status-submission';
    return await this.putOne(id,payload,opts);
  }
  async deletePesanan(id,opts={}){
    this.endPoint = '/submission';
    return await this.delete(id,opts);
  }
}

export default new Pesanan();